export default {
	label: 'Mon Compte',
	project: '',
	links: [
		{
			title: 'Accueil',
			// Must be a route name, cf => /router.ts
			to: {
				name: 'home'
			},
			disabled: false,
			rule: 'seeHome'
		}
	],
	logOut: 'Déconnexion',
	role: {
		ROLE_USER: 'Utilisateur',
		ROLE_BILLING_ENTRY_USER: 'Utilisateur',
		ROLE_EDS_USER: 'Utilisateur',
		ROLE_PEPS_USER: 'Utilisateur',
		ROLE_IPEP_USER: 'Utilisateur',
		ROLE_PHARMACIST: 'Pharmacien',
		ROLE_MOBILE_TEAM: 'Équipe mobile',
		ROLE_ADMIN_LOCAL: 'Administrateur local',
		ROLE_BILLING_FILE_USER: 'Administratif',
		ROLE_PROJECT_MANAGER: 'Chef de projet',
		ROLE_FINANCIAL_CONTROLLER: 'Financier'
	},
	roleAccessMaster: {
		A51_NAT_VAL: 'Valideur national',
		A51_NAT_DGOS: 'Validateur DGOS',
		A51_NAT_ADM: 'Administrateur national',
		A51_CPAM_LIQ: 'Agent liquidateur',
		A51_CPAM_MNG_LIQ: 'Manager liquidateur',
		A51_CPAM_SUPERVISOR: 'Agent organisme gestionnaire',
		A51_NAT_EXPATIENT: 'Administrateur des expériences patients'
	}
};
